import { render, staticRenderFns } from "./TipsAndTricksBuy.vue?vue&type=template&id=31bdaadb&scoped=true"
import script from "./TipsAndTricksBuy.vue?vue&type=script&lang=ts"
export * from "./TipsAndTricksBuy.vue?vue&type=script&lang=ts"
import style0 from "./TipsAndTricksBuy.vue?vue&type=style&index=0&id=31bdaadb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bdaadb",
  null
  
)

export default component.exports